import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { MapMarker } from 'transfix-ui/components/MapMarker'
import { makeStyles, Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { DISPLAY } from 'constants/display'
import { InlineRow } from '../../load-details/InlineRow'
import { DedicatedLaneFacilityRowBody } from './DedicatedLaneFacilityRowBody'

const useDedicatedLaneFacilityDetailsStyles = makeStyles({
  mapMarker: {
    marginRight: 10,
  },
})

export interface IDedicatedLaneFacilityDetailsProps {
  dedicatedLane?: DedicatedLanesResponse
}

export const DedicatedLaneFacilityDetails: FC<IDedicatedLaneFacilityDetailsProps> = ({
  dedicatedLane,
}) => {
  const { isMobile } = useBreakpointContext()
  const classes = useDedicatedLaneFacilityDetailsStyles()

  const { deliveryFacilities, pickupFacilities } = dedicatedLane ?? {}
  const [pickupFacility] = pickupFacilities ?? []
  const [deliveryFacility] = deliveryFacilities ?? []

  return (
    <Card>
      <Typography variant='subtitle1' className={isMobile ? 'mb3' : ''}>
        Facility Details
      </Typography>

      <InlineRow
        bodyClass={isMobile ? 'mt1 mb2' : 'mt1'}
        rowTitle={
          <Typography variant='body1'>
            <MapMarker className={classes.mapMarker} sequence={0} type='pickup' />
            Pickup Facility
          </Typography>
        }
        rowBody={
          pickupFacility ? (
            <DedicatedLaneFacilityRowBody
              dataTest='dedicated-lanes-facility-details-pickup'
              facility={pickupFacility}
            />
          ) : (
            <Typography variant='body1'>{DISPLAY.empty}</Typography>
          )
        }
      />

      <InlineRow
        bodyClass='mt1'
        rowTitle={
          <Typography variant='body1'>
            <MapMarker className={classes.mapMarker} sequence={0} type='delivery' />
            Dropoff Facility
          </Typography>
        }
        rowBody={
          deliveryFacility ? (
            <DedicatedLaneFacilityRowBody
              dataTest='dedicated-lanes-facility-details-delivery'
              facility={deliveryFacility}
            />
          ) : (
            <Typography variant='body1'>{DISPLAY.empty}</Typography>
          )
        }
      />
    </Card>
  )
}
